const radioButtonTokens = ({
  borders,
  colors,
  sizes,
  fontSizeBody,
  fontWeights,
}) => ({
  borders: borders[1],
  colors: {
    label: colors.neutrals[3],
    tick: {
      default: {
        iconColor: colors.white,
        bgColor: colors.white,
        borderColor: colors.neutrals[5],
        hover: {
          borderColor: colors.primary['50'],
        },
      },
      error: {
        iconColor: colors.critical.dark,
        bgColor: colors.critical.lightest,
        labelColor: colors.neutrals[3],
        borderColor: colors.red['90'],
      },
      disabled: {
        iconColor: colors.neutrals[5],
        bgColor: colors.neutrals[7],
        borderColor: colors.neutrals[6],
      },
      checked: {
        iconColor: colors.white,
        bgColor: colors.primary['50'],
        borderColor: colors.primary['50'],
        hover: {
          borderColor: colors.primary['50'],
        },
      },
    },
    circle: {
      default: {
        bgColor: colors.white,
        borderColor: colors.neutrals[5],
        hover: {
          borderColor: colors.primary['50'],
        },
      },
      error: {
        bgColor: colors.critical.lightest,
        borderColor: colors.red['90'],
        iconColor: colors.critical.dark,
        labelColor: colors.neutrals[3],
      },
      disabled: {
        bgColor: colors.neutrals[7],
        borderColor: colors.neutrals[5],
        iconColor: colors.neutrals[5],
      },
      checked: {
        bgColor: colors.white,
        borderColor: colors.neutrals[5],
        iconColor: colors.primary['50'],
        hover: {
          borderColor: colors.primary['50'],
        },
      },
    },
  },
  sizes: {
    minWidth: sizes[1],
    height: sizes[1],
  },
  lineHeight: '24px',
  fontSizes: fontSizeBody[2],
  fontWeights: {
    unchecked: fontWeights.normal,
    checked: fontWeights.normal,
  },
});

export default radioButtonTokens;
